
/* ----- Vue ----- */
import { Component, Vue, Prop, Emit } from "vue-property-decorator"
import { State } from "vuex-class"

/* ----- Components ----- */
import VueSelect from "vue-select"

/* ----- Services ----- */
import DataCache from "@/caching/caching"

/* ----- Types ----- */
import { Field } from "@/types"
import { DataType, dataTypeByFieldType } from "@/types/insights"

@Component({
	components: {
		"v-select": VueSelect
	}
})
export default class SimpleFieldSelect extends Vue {
	/* ----- Props ----- */
	@Prop({ type: [String, Array], default: null }) private readonly value!: string | string[] | null
	@Prop({ type: Number, required: false }) private readonly dataType?: DataType
	@Prop({ type: Boolean, default: false }) private readonly multiple!: boolean
	@Prop({ type: Boolean, default: false }) private readonly disabled!: boolean
	@Prop({ type: Boolean, default: false }) private readonly required!: boolean
	@Prop({ type: String, default: "" }) private readonly placeholder!: string

	/* ----- Vuex ----- */
	@State private readonly fieldCache!: DataCache<Field>

	/* ----- Data ----- */
	private isMounted: boolean = false

	/* ----- Lifecycle ----- */

	private async mounted () {
		await this.fieldCache.fetchIfNeeded()
		this.isMounted = true
	}

	/* ----- Computed Properties ----- */

	private get fieldOptions (): { label: string; value: string; dataType: DataType | null }[] {
		let result = this.fieldCache.items

		if (this.dataType !== undefined && this.dataType !== null) {
			result = result.filter(field => dataTypeByFieldType[field.dataType!] === this.dataType)
		}

		return result.map(field => ({
			label: field.title,
			value: field.id!,
			dataType: dataTypeByFieldType[field.dataType!]
		}))
	}

	/* ----- Vue-related Methods ----- */

	@Emit("input")
	private setValue (newValue: string | string[]) {
		return newValue
	}

	/* ----- Other Methods ----- */
}
